import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import User from '../../admin/User';
import Video from '../../admin/Video';
import TransactionHistory from '../../admin/Referral-Manager/TransactionHistory.js';
import UserInfo from '../../admin/UserInfo.js';
import ReferTeacher from '../../admin/ReferTeacher.js';
import Notification from '../../admin/Notification.js';
import Paid from '../../admin/Paid.js';
import Free from '../../admin/Free.js';
import TeacherNotifications from '../../admin/TeacherNotifications.js';
import CourseDiscount from '../../admin/CourseDiscount.js';
import VideoNew from '../../admin/VideoNew.jsx';
import ScheduledLectures from '../../admin/ScheduledLectures.jsx';
import VideoPolls from '../../admin/VideoPolls.jsx';
import VideoQuestions from '../../admin/VideoQuestions.jsx';
import ScheduleNewLecture from '../../admin/ScheduleNewLecture.jsx';
import ScheduleLiveLecture from '../../admin/ScheduleLiveLecture.jsx';
import ScheduledSessions from '../../admin/ScheduledSessions.jsx';
import VideoLive from '../../admin/VideoLive.jsx';
import ScheduledSessionNew from '../../admin/ScheduledSessionNew.jsx';
import SessionPolls from '../../admin/SessionPolls.jsx';
import ScheduledLecturesNew from '../../admin/ScheduledLecturesNew.jsx';
import Batch from '../../admin/Content-Management/Batch.jsx';
import Plans from '../../admin/Content-Management/Plans.jsx';
import Notes from '../../admin/Notes.jsx';
import Elibrary from '../../admin/Elibrary.jsx';
import MarketplaceDiscount from '../../admin/MarketplaceDiscount.js';
import LecturesManagement from '../../admin/LecturesManagement.jsx';
import VideoLibrary from '../../admin/VideoLibrary.jsx';
import ScheduleLiveLectureForm from "../../components/video-components/Schedule-leacture-form.jsx";

const Dashboard = lazy(() => import('../../container/dashboard'));
const Role = lazy(() => import('../../admin/Role'));
const Chapter = lazy(() => import('../../admin/Chapter'));
const Course = lazy(() => import('../../admin/Content-Management/Course'));
const FrontCourse = lazy(() => import('../../admin/Content-Management/FrontCourse'));
const Student = lazy(() => import('../../admin/Student'));
const Subject = lazy(() => import('../../admin/Content-Management/Subject'));
const SubjectContent = lazy(() => import('../../admin/Content-Management/SubjectContent'));
const Teacher = lazy(() => import('../../admin/Teacher'));
const Topic = lazy(() => import('../../admin/Topic'));
const Class = lazy(() => import('../../admin/Content-Management/Class'));
const File = lazy(() => import('../../admin/Content-Management/File'));
const QuestionUpload = lazy(() => import('../../admin/Content-Management/QuestionUpload'));
const AddDetails = lazy(() => import('../../admin/Content-Management/AddDetails'));
const Question = lazy(() => import('../../admin/Content-Management/Question'));
const Referral = lazy(() => import('../../admin/Referral'));
const Refer = lazy(() => import('../../admin/Referral-Manager/Refer.js'));
const QueDetails = lazy(() => import('../../admin/Practice-Management/QueDetails'));
const UserPracticeDetails = lazy(() => import('../../admin/Practice-Management/UserPracticeDetails'));
const ReportedQuestions = lazy(() => import('../../admin/Practice-Management/ReportedQuestions'));
const PracticeDetails = lazy(() => import('../../admin/Practice-Management/PracticeDetails'));
const CreateTest = lazy(() => import('../../admin/Test/CreateTest'));
const TestDetails = lazy(() => import('../../admin/Test/TestDetails'));
const TestDetailsTeacher = lazy(() => import('../../admin/Test/TestDetailsTeacher'));
const Books = lazy(() => import('../../admin/MarketPlace-Management/Books'));
const DailyChallenge = lazy(() => import('../../admin/DailyChallenge-Managemnent/DailyChallenge'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />
        <Route path="role" element={<Role />} />
        {/* <Route path="chapter" element={<Chapter/>} /> */}
        <Route path="course" element={<Course />} />
        <Route path="batch" element={<Batch />} />
        <Route path="plans" element={<Plans />} />
        <Route path="front-course" element={<FrontCourse />} />
        <Route path="content-management" element={<SubjectContent />} />
        <Route path="notes" element={<Notes />} />
        <Route path="elibrary" element={<Elibrary />} />
        <Route path="marketplace-management" element={<Books />} />
        {/* <Route path="user" element={<User />} /> */}
        <Route path="student" element={<Student />} />
        <Route path="subject" element={<Subject />} />
        <Route path="teacher" element={<Teacher />} />
        {/* <Route path="topic" element={<Topic/>} /> */}
        <Route path="class" element={<Class />} />
        <Route path="practice-management" element={<QueDetails />} />
        <Route path="reported-questions" element={<ReportedQuestions />} />
        <Route path="practice-details" element={<UserPracticeDetails />} />
        <Route path="practice-details/*" element={<PracticeDetails />} />
        {/* <Route path="file" element={<File/>} /> */}
        {/* <Route path="referral" element={<Referral/>} /> */}
        <Route path="subject/*" element={<File />} />
        <Route path="question/*" element={<Question />} />
        <Route path="refer" element={<Refer />} />
        <Route path="transactionhistory" element={<TransactionHistory />} />
        <Route path="video/*" element={<Video />} />
        <Route path="userinfo/*" element={<UserInfo />} />
        <Route path="referteacher/*" element={<ReferTeacher />} />
        <Route path="notification/*" element={<Notification />} />
        <Route path="paid" element={<Paid />} />
        <Route path="free" element={<Free />} />
        <Route path="teacher-notification" element={<TeacherNotifications />} />
        <Route path="test" element={<CreateTest />} />
        <Route path="test/details" element={<TestDetails />} />
        <Route path="test/teacher/details" element={<TestDetailsTeacher />} />
        <Route path="course-discounts" element={<CourseDiscount />} />
        <Route path="marketplace-discounts" element={<MarketplaceDiscount />} />
        <Route path="daily-challenge" element={<DailyChallenge />} />
        <Route path="question-upload" element={<QuestionUpload />} />
        <Route path="subject-add-details" element={<AddDetails />} />
        <Route path="class" element={<Class />} />
        <Route path="practice-details" element={<QueDetails />} />
        {/* <Route path="file" element={<File/>} /> */}
        {/* <Route path="referral" element={<Referral/>} /> */}
        <Route path="subject/*" element={<File />} />
        <Route path="question/*" element={<Question />} />
        <Route path="refer" element={<Refer />} />
        <Route path="transactionhistory" element={<TransactionHistory />} />
        <Route path="assigned-courses-and-subjects" element={<VideoNew />} />
        <Route path="scheduled-lectures/*" element={<ScheduledLecturesNew />} />
        <Route path="scheduled-sessions/*" element={<ScheduledSessionNew />} />
        <Route path="scheduled-sessions/:roomKey/live-session" element={<VideoLive />} />
        <Route path="schedule-new-lecture/*" element={<ScheduleNewLecture />} />
        <Route path="schedule-live-lecture/*" element={<ScheduleLiveLecture />} />
        <Route path="scheduled-lectures/:videoId/video-polls" element={<VideoPolls />} />
        <Route path="scheduled-sessions/:videoId/video-polls" element={<SessionPolls />} />
        <Route path="scheduled-lectures/:videoId/video-questions" element={<VideoQuestions />} />
        <Route path="scheduled-sessions/:videoId/video-questions" element={<VideoQuestions />} />
        {/* <Route path="userinfo/*" element={<UserInfo />} /> */}
        <Route path="referteacher/*" element={<ReferTeacher />} />
        <Route path="lectures-management" element={<LecturesManagement />} />
        <Route path="Schedule-leacture-form" element={<ScheduleLiveLectureForm />} />
        <Route path="video-library" element={<VideoLibrary />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
